/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import ControlComponent from 'ember-bootstrap/components/bs-form/element/control';

export default class PowerSelectControl extends ControlComponent {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'bs-form/element/control/power-select': typeof PowerSelectControl;
  }
}
